import { CURRENCIES, formatTripsterMoney, formatTripsterNumber } from '@experience/money-utils';

type CurrencyCode = keyof typeof CURRENCIES;

const isCurrencyCode = (code: string): code is CurrencyCode => code in CURRENCIES;

export function formatFilterPriceMoney(amount: number | string, currencyCode: string, currencySymbol: string): string {
  const code = currencyCode.toUpperCase();

  if (typeof amount === 'number' && isCurrencyCode(code)) {
    return formatTripsterMoney(amount, code);
  }

  const value = typeof amount === 'number' ? formatTripsterNumber(amount) : amount;

  if (isCurrencyCode(code)) {
    const { orientation, sign } = CURRENCIES[code];
    const separator = '\u2009';
    const signOrientation = orientation as 'before' | 'after';

    return signOrientation === 'before' ? `${sign}${separator}${value}` : `${value}${separator}${sign}`;
  }

  return `${value}\u2009${currencySymbol}`;
}
